module.exports = __webpack_public_path__ + "static/media/facilities.afbbf176.svg";